import { TRANSPARENT } from '../theme/settings';

// work this out into something more of a script/fn later.

export const overrides = {
    MuiTooltip: {
        tooltip: {
            position: 'relative',
            maxWidth: 400,
            padding: 10,
            borderRadius: 5,
            borderWidth: 1,
            borderStyle: 'solid',
            fontSize: 12
        },
        arrow: {
            fontSize: 10,
            position: 'absolute',
            height: 7,
            width: 14,
            overflow: 'hidden',
            background: TRANSPARENT,
            border: '0',
            color: TRANSPARENT,

            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                border: `1px solid ${TRANSPARENT}`,
                height: 20,
                width: 20
            }
        },
        popperArrow: {
            '&[x-placement*="top"] $arrow, &[x-placement*="bottom"] $arrow': {
                height: 7,
                width: 14,

                '&::before': {
                    transformOrigin: 'center !important',
                    marginLeft: -4,
                    marginTop: 4
                }
            },
            '&[x-placement*="top"] $arrow': {
                '&::before': {
                    marginTop: -17
                }
            },
            '&[x-placement*="left"] $arrow, &[x-placement*="right"] $arrow': {
                height: 14,
                width: 7,

                '&::before': {
                    marginLeft: -8,
                    marginTop: -8
                }
            },
            '&[x-placement*="right"] $arrow': {
                '&::before': {
                    transformOrigin: 'center !important',
                    marginLeft: 4,
                    marginTop: -3 // just looked better than -4
                }
            }
        }
    }
};
